import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './ISQItem.module.scss';

import { Panel } from '../../components/Shared/Panel';

class ISQItem extends Component {
  constructor(props) {
    super(props);
    this.isqChanged = this.isqChanged.bind(this);
  }

  size() {
    switch (this.props.size) {
      case '' || null || undefined:
        return null;
      case 'small':
        return styles.small;
      case 'medium':
        return styles.medium;
      default:
        throw new Error('Unsupported tile size');
    }
  }

  getColor() {
    if (this.props.isq) {
      if (this.props.abutment) {
        return styles.neutral;
      } else if (this.props.isq >= 70) {
        return styles.high;
      } else if (this.props.isq >= 60) {
        return styles.mid;
      } else if (this.props.isq > 0) {
        return styles.low;
      }
    }
    return styles.noMeasurement;
  }

  flash() {
    if (this.props.active) return styles.active;

    if (this.props.updated) {
      return styles.flash;
    }
  }

  isqChanged(evt) {
    const text = evt.target.value;
    if (this.props.isqChanged) {
      if (text.length === 0 || (text.length < 3 && Number(text) > 0)) {
        this.props.isqChanged(this.props.direction, evt.target.value);
      }
    }
  }

  render() {
    const tile = classNames(styles.tile, this.size(), 'display', this.getColor(), this.flash());
    return (
      <Panel className={tile}>
        <div className={styles.header}>{this.props.direction}</div>
        <div className={styles.isq}>
          {this.props.editable ? (
            <input
              data-cy={this.props.dataCy && this.props.dataCy}
              className={styles.isqInput}
              type="text"
              value={this.props.isq}
              onChange={this.isqChanged}
              pattern="\d*"
            />
          ) : (
            this.props.isq
          )}
        </div>
        <div className={styles.colorIndicator}></div>
      </Panel>
    );
  }
}

export default ISQItem;
